import View from './ShareButton'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const ShareButton = connect(mapStateToProps)(View)

export default ShareButton
